var React = require('react');

function ArrowSimpleLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4","d":"M16.25 25.25 5.53 14.53a.75.75 0 0 1 0-1.06L16.25 2.75"}));
}

ArrowSimpleLeftInline.defaultProps = {"fill":"none","viewBox":"0 0 24 28"};

module.exports = ArrowSimpleLeftInline;

ArrowSimpleLeftInline.default = ArrowSimpleLeftInline;
